<template>
  <b-card no-body class="my-2">
    <b-card-header class="card-header-results border-0" :class="{ selectedPdf : selected}">
      <div class="card-header-result-label border-0 d-flex align-items-center">
        <b-button-group size="sm" class="mr-3" v-if="showBook">

          <b-iconstack @click="$emit('toggle')" v-b-tooltip.hover.left title=" Selecteaza PDF">
            <b-icon icon="square" stacked />
            <b-icon icon="check" v-if="selected" scale="0.9" stacked />
          </b-iconstack>

          <b-icon icon="info-square"  class="mx-1" v-b-tooltip.hover title="Mai mult" @click="$emit('info')"/>

          <b-icon
          :icon="collapsed ? 'dash' : 'plus'"
          v-b-toggle.accordion-1
          v-b-tooltip.hover.top :title=" collapsed ? 'mai putin' :'mai mult'"
          @click="toggleCollapse()"
          />

          <!-- <b-iconstack  variant="danger"  v-b-tooltip.hover title="Selecteaza PDF" @click="$emit('toggle')">
            <b-icon icon="square" stacked />
            <b-icon icon="check" v-if="selected" scale="0.7" stacked />
          </b-iconstack> -->

        </b-button-group>
        <div  class="header-title">
          <strong v-if="labelPart1">{{ labelPart1 }}</strong>
          <strong v-if="labelPart1">{{ labelPart2 }}</strong>
        </div>
      </div>
      <div class="d-flex justify-items-right">
        <div>
            <span class="header-date">{{ formatDate(result.date) }}</span>
            <span v-if="result.isBookable && result.isAvailable" class="FCAVL ml-2" v-b-tooltip.hover title="Disponibil">
              <b-icon icon="check-circle" font-scale="1.1"></b-icon>
            </span>
            <span v-else-if="result.isBookable" class="RQNA ml-2" v-b-tooltip.hover title="La cerere">
              <b-icon icon="chat-quote" font-scale="1.1"></b-icon>
            </span>
        </div>
        <div class="price-and-status" @click="$emit('priceDetails')">
          <span class="text-primary font-weight-bold"><span>Pret</span> : {{ result.gross }} {{ result.currency }}</span>
        </div>
      </div>
    </b-card-header>
    <b-card-body v-if="collapsed" class="pb-2">
      <b-row>
        <b-col md="3">
           <b-carousel
            id="carousel"
            controls
            indicators
            v-if="result.images && result.images.length">
            <b-carousel-slide v-for="(image,imageIndex) in result.images" :key="imageIndex">
              <template slot="img">
                <img :src="image" class="img-fluid w-100 d-block carousel-img"/>
              </template>
            </b-carousel-slide>
          </b-carousel>
          <img v-else src="@/assets/images/backgrounds/default-image.jpg" class="img-fluid" />
        </b-col>
        <b-col md="9" class="transport-info pl-4">
          <b-row class="mb-3">
            <b-col sm="5" class="align-items-center" :class="!result.location_name ? 'hidden' : ' ' ">
              <h6 class="location-title py-2">
                <b-icon icon="geo-alt" />&nbsp;
                locatia:&nbsp;&nbsp;<span ><strong>{{ result.location_name }}</strong></span>
              </h6>
            </b-col>
            <b-col sm="7">
              <div class="y-responsive">
                <b-table-simple responsive class="table table-sm date-table mb-0">
                  <b-tbody>
                    <template  v-for="(date, dateIndex) in result.dates"   >
                      <tr v-if="!datesCollapsed || date.date === result.date" :key="'date' + dateIndex">
                        <td>
                          <span v-if="showDatesCollapse && (datesCollapsed || !dateIndex)">
                            <b-icon
                            class="text-info border-info"
                            :icon="!datesCollapsed ? 'dash-square' : 'plus-square'"
                            @click="datesCollapsed = !datesCollapsed"
                            />
                          </span>
                          <span v-else class="px-1">&nbsp;</span>
                        </td>
                        <td :class="{
                          'font-weight-bold': !datesCollapsed && (date.date == result.date)
                        }">{{ formatDate(date.date) }}</td>
                        <td>
                          <span v-if="date.isBookable && date.isAvailable" class="FCAVL"><b-icon icon="check-circle"/></span>
                          <span v-else-if="date.isBookable" class="RQNA"><b-icon icon="chat-quote"/></span>
                          <span v-else class="RQNA"><b-icon icon="slash-circle"/></span>
                        </td>
                        <td>
                          <b-btn
                            size="sm"
                            variant="outline-primary"
                            type="button"
                            class="float-right my-0 py-0"
                            @click="$emit('book')"
                            v-if="showBook && date.isBookable"
                          >
                            {{ date.isAvailable ? 'Rezervare' : 'Cerere' }}
                          </b-btn>
                        </td>
                      </tr>
                    </template>
                  </b-tbody>
                </b-table-simple>
              </div>
            </b-col>
          </b-row>
          <span>
            {{ result.description }}
          </span>
        </b-col>
        <template v-if="showWebDescriptions">
          <b-col sm="12" v-for="(desc, index) in result.web_descriptions" :key="'desc' + index" class="py-1 mt-2">
            <h6>{{ desc.label}}</h6>
            <div v-html="desc.text"></div>
          </b-col>
          <!-- <b-col class="mt-3">
            <b-card bg-variant="light">
              <h5> <b-icon icon="exclamation-triangle-fill" class=" text-warning"/> General Conditions of Reservations and Cancellations for Local Tours:</h5>
              <h6 class="font-weight-bold">Important Notice</h6>
              <p class="p-0">Carefully read the following terms and conditions before buying any excursions/shore excursions online.</p>
              <h6 class="font-weight-bold">Excursions Terms &amp; Conditions</h6>
              <h6 class="font-weight-bold">General</h6>
              <p class="p-0">All excursions are subject to change due to weather-related safety considerations, or a minimum number of participants. Descriptions, departure times, itineraries, pricing and locations may be altered and may vary due to unforeseen circumstances.</p>
              <h6 class="font-weight-bold">Excursion Cancellation and Refund Policy</h6>
              <p class="p-0">Excursions may be cancelled by Knossos Travel or the Tour Operator for any reason whatsoever. In this event, a full refund will be issued, or the guests will be accommodated on an alternate excursion.</p>
              <h6 class="font-weight-bold">Individual Reservations</h6>
              <p class="mb-1 p-0">48 hours or more in advance of the excursion date - 100% refund</p>
              <p class="mb-1 p-0">24-48 hours in advance – only date changes will be accepted free of charge</p>
              <p class="p-0">No shows or late arrivals – no refund</p>
              <h6 class="font-weight-bold">Group Reservations</h6>
              <p class="mb-1 p-0">15 days or more in advance of the excursion date - 100% refund</p>
              <p class="mb-1 p-0">Less than 15 days prior to excursion date – only date change will be accepted free of charge</p>
              <p class="p-0">No shows or late arrivals – no refund</p>
            </b-card>
          </b-col> -->
        </template>
      </b-row>
      <!-- <b-row class="my-2">
        <b-col class="px-2"><Legend/></b-col>
      </b-row> -->
    </b-card-body>
  </b-card>
</template>

<script>
import moment from 'moment'

// import Legend from '../../shared/components/legend.vue'
export default {
  props: {
    result: {
      type: Object,
      required: true
    },
    showWebDescriptions: {
      type: Boolean,
      default: false
    },
    showBook: {
      type: Boolean,
      default: true
    },
    selected: Boolean,
    expanded: Boolean
  },
  // components: { Legend },
  data () {
    return {
      collapsed: this.expanded,
      datesCollapsed: true
    }
  },
  computed: {
    showDatesCollapse () { return this.result.dates.length > 1 },
    splitLabel () { return this.result.label.split('/') },
    labelPart1 () {
      return (this.splitLabel.length > 0) ? this.splitLabel[0] : ''
    },
    labelPart2 () {
      return (this.splitLabel.length > 1) ? this.splitLabel[1] : ''
    }
  },
  methods: {
    toggleCollapse () {
      this.collapsed = !this.collapsed
    },
    formatDate (date) {
      return moment(date, 'DD-MM-YYYY').format('ddd, DD MM YYYY')
    }
  }
}
</script>

<style lang="scss">
  .transport-info{
    white-space: pre-line;
  }
  .text-uppercase{
    text-transform: uppercase;
  }
  .hidden{
    visibility: hidden!important;
  }
  .header-date{
    display: inline-block;
    padding-top: 0.25rem;
  }
  .date-table{
    color:#625d57;
    td {
      border-top:2px solid #3c7eb7!important;
      border-bottom:2px solid #3c7eb7;
      padding: .4rem!important;
    }
  }

  .location-title {
    color:#625d57;
    border-top:2px solid #3c7eb7;
    border-bottom:2px solid #3c7eb7;
    padding: .3rem;
  }

  .y-responsive {
    max-height:200px;
    padding:0px;
    overflow:scroll;

    &:hover{
      box-shadow: 0px 1px 1px rgba(0,0,0,.25);
      cursor: pointer;
    }
  }
  .header-title {
    display: inline-block;
    line-height: 1.5rem;
    strong {
      display: block;
    }
  }
</style>
